import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFeature, PRINT_ORDERING } from '../contexts/ConfigContext';
import styles from './Header.module.css';

export function Header() {
  const { authenticated, logout } = useAuth();
  const printOrderingEnabled = useFeature(PRINT_ORDERING);

  return (
    <header className={styles.header}>
      <Link to="/" aria-label="Loupe home">
        <img
          src="/assets/logo.svg"
          alt="Loupe — CDL"
          className={styles.logo}
        />
      </Link>

      {authenticated && (
        <nav className={styles.nav} aria-label="Main navigation">
          <Link to="/orders" className={styles.navLink}>
            Orders
          </Link>
          {printOrderingEnabled && (
            <Link to="/print" className={styles.navLink}>
              Print
            </Link>
          )}
          <a
            href="https://chemicaldependency.co.uk"
            className={styles.navLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Store
          </a>
          <button
            type="button"
            className={styles.logoutButton}
            onClick={logout}
          >
            Log out
          </button>
        </nav>
      )}
    </header>
  );
}
